export default {
  DISABLED: '已失效',
  CANCELED: '已取消',
  REJECTED: '未通过',
  VERIFIED: '审核通过',
  PENDING: '待审核',
  SUBMITTED: '待提交',
  goto_fee: '去缴费',
  goto_edit: '去修改',
  goods_rental: '商品租赁',
  will_pay_with: '必缴费用',
  the_figure: '报图',
  titles: '展位详情',
  exhibiting_company: '参展商',
  linkman: '联系人',
  contact_number: '联系电话',
  '非法访问!': '非法访问!',
  "展位列表": "展位列表",
  "展位概况": "展位概况",

  "报图信息": "报图信息",
  "展位基础信息": "展位基础信息",
  "展会费用": "展会费用",
  "审核状态": "审核状态",
  "报图时间": "报图时间",
  "承建商": "承建商",
  "未通过报图": "未通过报图",
  "去报图": "去报图",
  "修改报图": "修改报图",
  "费用缴纳": "费用缴纳",
  "未缴纳用项": "未缴纳用项",
  "去缴费": "去缴费",

}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/boothInfo.js